import { toast } from "sonner";
import { setMediaOrder } from "@/lib/api";

export const AD_KINDS = ["image", "video", "paper"];
export const aid = (m) => m.smartsheet_attachment_id;
export const isPdfItem = (m) => (m.mime_type || "").includes("pdf") || /\.pdf$/i.test(m.name || "");

// Included attachments in their saved advertisement order.
export const adSequence = (media) =>
  (media || []).filter((m) => AD_KINDS.includes(m.kind) && m.ad_order).sort((a, b) => a.ad_order - b.ad_order);

// Default slots: photos, then registration papers, then videos.
export function withInserted(seq, m) {
  const ranks = m.kind === "image" ? ["image"] : m.kind === "paper" ? ["image", "paper"] : AD_KINDS;
  let at = 0;
  seq.forEach((x, i) => { if (ranks.includes(x.kind)) at = i + 1; });
  if (m.kind === "video") at = seq.length;
  return [...seq.slice(0, at), m, ...seq.slice(at)];
}

export async function saveSequence(horseId, media, seq, onChange) {
  const orders = {};
  (media || []).filter((m) => AD_KINDS.includes(m.kind) && m.kind !== "paper").forEach((m) => { orders[aid(m)] = null; });
  seq.forEach((m, i) => { orders[aid(m)] = i + 1; });
  try { onChange(await setMediaOrder(horseId, orders)); } catch (e) { toast.error(e.response?.data?.detail || "Could not save the order"); }
}
